import React from 'react';
import { supportHref } from '@support/preferred-email-client';
import styles from './EmailConfirmation.module.scss';

const ErrorBox = ({ children }) => <div className={styles.errorBox}>{children}</div>;

export const GenericError = () => (
  <>
    <ErrorBox>Sorry, something went wrong.</ErrorBox>
    <div style={{ marginBottom: 48, marginTop: 32 }}>
      Please try again or
      <br />
      <a href={supportHref({ subject: 'Issue logging in with email' })}>contact us</a>.
    </div>
  </>
);

export const AccountNotFoundError = () => (
  <div style={{ marginBottom: 72 }}>
    Log in using your usual sign-in
    <br />
    method (Apple, Google or a different
    <br />
    email). Add this email to your account in
    <br />
    <b>Settings</b>
    <small>→</small>
    <b>General</b>
    <small>→</small>
    <b>Sign In Accounts</b>.{/* </div> */}
  </div>
);

export const EmailInUseError = ({ email }: { email?: string }) => (
  <>
    <ErrorBox>
      <span style={{ fontWeight: 'bold' }}>{email}</span> is already connected to an existing Clay
      account.
    </ErrorBox>
    <div
      style={{
        marginBottom: 32,
        marginTop: 16,
      }}
    >
      Log in using your usual sign-in
      <br />
      method (Apple, Google or a different
      <br />
      email). Add this email to your account in
      <br />
      <b>Settings</b>
      <small>→</small>
      <b>General</b>
      <small>→</small>
      <b>Sign In Accounts</b>.
    </div>
  </>
);
